export const makeAudioContext = () => {
  const AudioContextClass =
    window.AudioContext ||
    (
      window as Window & {
        webkitAudioContext?: typeof AudioContext;
      }
    ).webkitAudioContext;
  if (!AudioContextClass) {
    throw new Error('AudioContext is not supported');
  }
  return new AudioContextClass();
};
